const myLib = require('../lib/MyLib');
export function validate(kehoach) {
    var result = {error: false};
    if (myLib.isEmpty(kehoach.TenTau)) {
        result.error = true;
        result.TenTau = {error: true, trangthai: 'Chưa có tên tàu!'};
      }
    if (myLib.isEmpty(kehoach.BatDau)) {
        result.error = true;
        result.BatDau = {error: true, trangthai: 'Chưa có thời gian bắt đầu'};
      }
    return result;
}
export function chuanHoaKeHoach(action, sukien) {
  switch (action) {
      case 'abc':
          break;
    default:
      sukien.TenTau = (sukien.TenTau ? sukien.TenTau : '').toUpperCase();
      sukien.BatDau = sukien.BatDau ? new Date(sukien.BatDau.setMilliseconds(0)) : sukien.BatDau;
      sukien.KetThuc = sukien.KetThuc ? new Date(sukien.KetThuc.setMilliseconds(0)) : sukien.KetThuc;
      break;
  }
  return sukien;
}
export function chuyenDoi(sukien) {
  sukien.BatDau = myLib.fromServerTime(sukien.BatDau); //server dang hieu la local nen phai chuyen thanh utc
  sukien.KetThuc = sukien.KetThuc !== undefined && sukien.KetThuc != null ? myLib.fromServerTime(sukien.KetThuc) : undefined; //server dang hieu la local nen phai chuyen thanh utc
  sukien.TenTau = {value: sukien.TenTau, label: sukien.TenTau};
  return sukien;
}
